import {
  studentOrdersLoad,
  teacherOrders,
  myIncomesLoad
} from '../../../api/xs/teacher'
import {
  myPurchasedCoursesLoad,
  teacherCoursesLoad
} from '../../../api/xs/course'

// 我的订单
async function loadMyOrders(_ctx, query) {
  const R = await studentOrdersLoad(query)
  // const R1 = {
  //   total: 100,
  //   list: [{
  //     id: 1,
  //     orderNum: 'xxxxx',
  //     uid: 111,
  //     cid: 11,
  //     money: 1000,
  //     realMoney: 1000,
  //     payType: 1,
  //     payChannel: 1,
  //     source: 1000,
  //     status: 1,
  //     ctime: ''
  //   }, {
  //     id: 2,
  //     orderNum: 'xxxxx',
  //     uid: 134,
  //     cid: 12,
  //     money: 1000,
  //     realMoney: 1000,
  //     payType: 1,
  //     payChannel: 1,
  //     source: 1000,
  //     status: 1,
  //     ctime: ''
  //   }],
  //   courseMap: {
  //     11: {
  //       id: 11,
  //       name: '古希腊文化与哲学系列古希腊文化',
  //       des: '课程描述内容课程描述内容课程描述内容',
  //       levels: 'xxx', // 级别
  //       roomId: 5, // 互动ID
  //       money: 1999,
  //       realMoney: 99,
  //       views: 333,
  //       sales: 999,
  //       image: 'https://img.alicdn.com/imgextra/i3/672246894/TB2rBADr8smBKNjSZFsXXaXSVXa_!!672246894-0-daren.jpg_250x250xz.jpg',
  //       ctime: ''
  //     },
  //     12: {
  //       id: 12,
  //       name: '古希腊文化与哲学系列古希腊文化',
  //       des: '课程描述内容课程描述内容课程描述内容',
  //       levels: 'xxx', // 级别
  //       roomId: 5, // 互动ID
  //       money: 1999,
  //       realMoney: 99,
  //       views: 333,
  //       sales: 999,
  //       image: 'https://img.alicdn.com/imgextra/i2/1120709702/TB21T3aubwrBKNjSZPcXXXpapXa_!!1120709702-0-beehive-scenes.jpg_250x250xz.jpg',
  //       ctime: ''
  //     }
  //   },
  //   ctMap: {
  //     11: [],
  //     12: []
  //   }
  // }
  return R
}

// 我的售卖记录（学生购买）
async function loadMySales(_ctx, query) {
  const R = await teacherOrders(query)
  //   const R = {
  //     total: 100,
  //     list: [{
  //       id: 1,
  //       orderNum: 'xxxxx',
  //       uid: 111,
  //       cid: 11,
  //       money: 1000,
  //       realMoney: 1000,
  //       payType: 1,
  //       payChannel: 1,
  //       source: 1000,
  //       status: 1,
  //       ctime: ''
  //     }, {
  //       id: 2,
  //       orderNum: 'xxxxx',
  //       uid: 134,
  //       cid: 12,
  //       money: 1000,
  //       realMoney: 1000,
  //       payType: 1,
  //       payChannel: 1,
  //       source: 1000,
  //       status: 1,
  //       ctime: ''
  //     }],
  //     courseMap: {
  //       11: {},
  //       12: {}
  //     },
  //     ctMap: {
  //       11: [],
  //       12: []
  //     }
  //   }
  return R
}

// 收入记录
async function loadMyIncomes(_ctx, query) {
  const R = await myIncomesLoad(query)
  //   const R = {
  //     total: 100,
  //     reward: 99999,
  //     list: [{
  //       objId: 1,
  //       money: 10000,
  //       reward: 8888,
  //       refId: 1,
  //       backup: '古希腊文化与哲学系列古希腊文化',
  //       ctime: ''
  //     }, {
  //       objId: 2,
  //       money: 10000,
  //       reward: 8888,
  //       refId: 1,
  //       backup: '开国大典',
  //       ctime: ''
  //     }, {
  //       objId: 4,
  //       money: 10000,
  //       reward: 8888,
  //       refId: 1,
  //       backup: '古希腊文化与哲学系列古希腊文化',
  //       ctime: ''
  //     }, {
  //       objId: 5,
  //       money: 10000,
  //       reward: 8888,
  //       refId: 1,
  //       backup: '开国大典',
  //       ctime: ''
  //     }]
  //   }
  return R
}
async function loadMyPurchasedCourse({ state, dispatch }) {
  const uid = await dispatch('loadMyUid', {}, { root: true })
  if (uid > 0) {
    const res = await myPurchasedCoursesLoad()
    if (res && res.list) {
      state.myPurchasedCourse = res.list
    }
  }
}
async function loadMyPublishedCourse({ state, dispatch }) {
  const uid = await dispatch('loadMyUid', {}, { root: true })
  if (uid > 0) {
    const res = await teacherCoursesLoad()
    if (res && res.list) {
      state.myPublishedCourse = res.list
    }
  }
}

export default {
  loadMyOrders,
  loadMySales,
  loadMyIncomes,
  loadMyPurchasedCourse,
  loadMyPublishedCourse
}
